
import { Signal } from "signals";
import ReelComponent from "slotworks/components/matrix/reel/reel-component";
import { AnticipationInfo } from "slotworks/model/gameplay/records/spin-record";
import Contract from "slotworks/utils/contract";
abstract class AbstractReelTransition {

    public onReelLand: Signal;
    protected reels: ReelComponent[];

    public init(reels: ReelComponent[], stops: number[], reelset: string[][]) {
        this.reels = reels;
    }

    public start(reelset?: string[][], jumpStart: boolean = false): Contract<void> {
        return new Contract<void>((resolve) => {
            resolve(null);
        });
    }

    public stop(stops: number[], reelset: string[][], quickSpin: boolean, anticipation: AnticipationInfo): Contract<void> {
        return new Contract<void>((resolve) => {
            resolve(null);
        });
    }

    public skip(stops: number[], reelset: string[][]): Contract<void> {
        return new Contract<void>((resolve) => {
            resolve(null);
        });
    }

    public hold(reelIndexes?: number[]) {
        // Hold specified reels
    }

    public jump(stops: number[], reelset: string[][]) {
        // jump to stops
    }

    public update() {
        // Update tick for transition
    }
}

export default AbstractReelTransition;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/reel/transition-behaviours/abstract-reel-transition.ts